import React from "react";
import FontAwesome from "react-fontawesome";
import classNames from "classnames/bind";
import moduleStyles from "./OverlayLoader.module.scss";
import { OverlayLoaderProps } from "./types";

const cx = classNames.bind(moduleStyles);

/**
 * @deprecated
 */
const OverlayLoader = ({ text }: OverlayLoaderProps) => {
  return (
    <div className={cx("overlayLoader")}>
      <div className={cx("message")}>
        <FontAwesome
          name="cog"
          className={cx("icon")}
          spin
        />

        {text}
      </div>
    </div>
  );
};

export default OverlayLoader;
